import { render } from "./P042.vue?vue&type=template&id=9437798c&scoped=true"
import script from "./P042.vue?vue&type=script&lang=js"
export * from "./P042.vue?vue&type=script&lang=js"

import "./P042.vue?vue&type=style&index=0&id=9437798c&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9437798c"]])

export default __exports__